export const SET_ENTITY_ID = 'SET_ENTITY_ID'
export const SET_COMMENTS = 'SET_COMMENTS'
export const LOAD_MORE_COMMENTS = 'LOAD_MORE_COMMENTS'
export const SET_COMMENTS_LOADING = 'SET_COMMENTS_LOADING'
export const SET_EDITED_COMMENT = 'SET_EDITED_COMMENT'
export const SET_CURRENT_COMMENT = 'SET_CURRENT_COMMENT'
export const SET_IS_MESSAGE_BEING_EDITED = 'SET_IS_MESSAGE_BEING_EDITED'
export const SET_ERROR = 'SET_ERROR'
export const SET_PAGE = 'SET_PAGE'
export const SET_MAX_PAGE = 'SET_MAX_PAGE'
export const RESET_COMMENTS_DATA = 'RESET_COMMENTS_DATA'